module.exports = __webpack_public_path__ + "img/Windsurfen.88e94821.svg";